// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EypA3u_2RVsbqjQy {
  height: 97px;
  background-color: #20336c;
  position: fixed;
  width: 100%;
  z-index: 1200 !important;
  display: flex;
  top: 0;
  transition: transform 240ms cubic-bezier(0.22, 1, 0.36, 1);
}

.IgJfmDLs0W4MEpIe {
  width: 100%;
  margin: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.e9YUApulkUs4fdGn {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.u7mO6PQ9kQgbyBKd {
  height: 27px;
}

.GMM6XGoCh5AlaghF {
  color: white;
  border-color: white;
  padding: 14px 14px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: normal;
  display: block;
}

.QnLnpFWYYqYsrTbF {
  display: flex;
  align-items: center;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 12px 25px;
  border-radius: 16px;
  font-size: 13px;
  transition: all 0.4s ease-in;
}

.QnLnpFWYYqYsrTbF i {
  margin-right: 13px;
}

.QnLnpFWYYqYsrTbF:hover {
  color: #20336c;
  background-color: #ffffff;
}

.LE2Bvml7nUgWFapC {
  color: #fff;
}

.LE2Bvml7nUgWFapC span {
  font-size: 20px;
}

.HV6M7r9_lAqMG309 {
  position: absolute;
  right: 72px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  z-index: 1004;
}

@media screen and (max-width: 1024px) {
  .HV6M7r9_lAqMG309 {
    right: 40px;
  }
}

@media screen and (max-width: 768px) {
  .HV6M7r9_lAqMG309 {
    right: 24px;
  }
}

.RsmgarziTPwHzr4J {
  display: block;
  width: 24px;
  height: 2px;
  background: #ffffff;
  border-radius: 2px;
  transform-origin: center;
  transition:
    transform 280ms cubic-bezier(0.22, 1, 0.36, 1),
    opacity 200ms ease,
    width 280ms cubic-bezier(0.22, 1, 0.36, 1);
}

.NYUPsUjqNXsU_HjQ .RsmgarziTPwHzr4J:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.NYUPsUjqNXsU_HjQ .RsmgarziTPwHzr4J:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}

.NYUPsUjqNXsU_HjQ .RsmgarziTPwHzr4J:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

@media screen and (max-width: 1280px) {
  .EypA3u_2RVsbqjQy {
    height: 65px;
  }

  .u7mO6PQ9kQgbyBKd {
    height: 20px;
  }
}

@media screen and (max-width: 1240px) {
  .e9YUApulkUs4fdGn {
    width: 100%;
    padding: 0 28px;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 1024px) {
  .e9YUApulkUs4fdGn {
    padding: 0 24px;
  }
}

@media screen and (max-width: 1100px) {
  .IgJfmDLs0W4MEpIe {
    width: 100vw;
    flex-direction: row;
    justify-content: space-between;
  }
}

@media screen and (max-width: 768px) {
  .EypA3u_2RVsbqjQy {
    height: 70px;
  }

  .QnLnpFWYYqYsrTbF {
    font-size: 12px;
    border: none;
    padding: 12px 0px;
  }

  .QnLnpFWYYqYsrTbF i {
    margin-right: 0;
    font-size: 12px;
    margin-right: 5px;
  }

  .e9YUApulkUs4fdGn {
    padding: 0 16px;
  }
}

@media screen and (max-width: 520px) {
  .EypA3u_2RVsbqjQy {
    height: 74px;
  }

  .u7mO6PQ9kQgbyBKd {
    height: 30px;
  }

  .e9YUApulkUs4fdGn {
    padding: 0 24px;
  }
}

/* shift global header down when offline banner visible */
body.DowDxUNPLIqV5Flj .EypA3u_2RVsbqjQy {
  transform: translateY(28px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,MAAM;EACN,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB;;;8CAG4C;AAC9C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;AAC7B","sourcesContent":[".header {\r\n  height: 97px;\r\n  background-color: #20336c;\r\n  position: fixed;\r\n  width: 100%;\r\n  z-index: 1200 !important;\r\n  display: flex;\r\n  top: 0;\r\n  transition: transform 240ms cubic-bezier(0.22, 1, 0.36, 1);\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  margin: 0 40px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.containerStudent {\r\n  width: 1180px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.logo {\r\n  height: 27px;\r\n}\r\n\r\n.logoutButton {\r\n  color: white;\r\n  border-color: white;\r\n  padding: 14px 14px 12px;\r\n  border-radius: 16px;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  display: block;\r\n}\r\n\r\n.orderStatusLink {\r\n  display: flex;\r\n  align-items: center;\r\n  color: #ffffff;\r\n  border: 1px solid #ffffff;\r\n  padding: 12px 25px;\r\n  border-radius: 16px;\r\n  font-size: 13px;\r\n  transition: all 0.4s ease-in;\r\n}\r\n\r\n.orderStatusLink i {\r\n  margin-right: 13px;\r\n}\r\n\r\n.orderStatusLink:hover {\r\n  color: #20336c;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.sidebarBtn {\r\n  color: #fff;\r\n}\r\n\r\n.sidebarBtn span {\r\n  font-size: 20px;\r\n}\r\n\r\n.burgerBtn {\r\n  position: absolute;\r\n  right: 72px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 32px;\r\n  height: 32px;\r\n  background: transparent;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n  z-index: 1004;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .burgerBtn {\r\n    right: 40px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .burgerBtn {\r\n    right: 24px;\r\n  }\r\n}\r\n\r\n.burgerBar {\r\n  display: block;\r\n  width: 24px;\r\n  height: 2px;\r\n  background: #ffffff;\r\n  border-radius: 2px;\r\n  transform-origin: center;\r\n  transition:\r\n    transform 280ms cubic-bezier(0.22, 1, 0.36, 1),\r\n    opacity 200ms ease,\r\n    width 280ms cubic-bezier(0.22, 1, 0.36, 1);\r\n}\r\n\r\n.burgerOpen .burgerBar:nth-child(1) {\r\n  transform: translateY(8px) rotate(45deg);\r\n}\r\n\r\n.burgerOpen .burgerBar:nth-child(2) {\r\n  opacity: 0;\r\n  transform: scaleX(0);\r\n}\r\n\r\n.burgerOpen .burgerBar:nth-child(3) {\r\n  transform: translateY(-8px) rotate(-45deg);\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .header {\r\n    height: 65px;\r\n  }\r\n\r\n  .logo {\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1240px) {\r\n  .containerStudent {\r\n    width: 100%;\r\n    padding: 0 28px;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .containerStudent {\r\n    padding: 0 24px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  .container {\r\n    width: 100vw;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .header {\r\n    height: 70px;\r\n  }\r\n\r\n  .orderStatusLink {\r\n    font-size: 12px;\r\n    border: none;\r\n    padding: 12px 0px;\r\n  }\r\n\r\n  .orderStatusLink i {\r\n    margin-right: 0;\r\n    font-size: 12px;\r\n    margin-right: 5px;\r\n  }\r\n\r\n  .containerStudent {\r\n    padding: 0 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .header {\r\n    height: 74px;\r\n  }\r\n\r\n  .logo {\r\n    height: 30px;\r\n  }\r\n\r\n  .containerStudent {\r\n    padding: 0 24px;\r\n  }\r\n}\r\n\r\n/* shift global header down when offline banner visible */\r\nbody.offline-banner-visible .header {\r\n  transform: translateY(28px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var header = `EypA3u_2RVsbqjQy`;
export var container = `IgJfmDLs0W4MEpIe`;
export var containerStudent = `e9YUApulkUs4fdGn`;
export var logo = `u7mO6PQ9kQgbyBKd`;
export var logoutButton = `GMM6XGoCh5AlaghF`;
export var orderStatusLink = `QnLnpFWYYqYsrTbF`;
export var sidebarBtn = `LE2Bvml7nUgWFapC`;
export var burgerBtn = `HV6M7r9_lAqMG309`;
export var burgerBar = `RsmgarziTPwHzr4J`;
export var burgerOpen = `NYUPsUjqNXsU_HjQ`;
var _1 = `DowDxUNPLIqV5Flj`;
export { _1 as "offline-banner-visible" };
export default ___CSS_LOADER_EXPORT___;
